export default __webpack_public_path__ + "static/media/logo.d05436a4.png";